module.exports = __webpack_public_path__ + "img/dne-international.1afbdf47.svg";